app.directive('countyMultiple', function($q, $http, $timeout) {
    return {
        restrict: 'E',
        scope: {
            tmModel: '=' 
        },
        templateUrl: "/assets/js/angular/components/directives/terytmultiple/types/county.html",
        link: function(scope) {
            scope.data = {
                readonly: false,
                selectedItem: null,
                searchText: null,
                //selected: [],
                autocompleteDemoRequireMatch: true,
                transformChip: function transformChip(chip) {
                    if (angular.isObject(chip)) {
                        return chip;
                    }

                    return {
                        name: chip,
                        type: 'new'
                    }
                },

                querySearch: function(query) {
                    var deferred = $q.defer();
                    $http.post('/terytmulti/county', {
                        'name': query,
                        'assigned': scope.tmModel
                    }).success(function(data) {
                        deferred.resolve(data);
                    });
                    return deferred.promise;
                }
            };
        }
    };
});
